import { ArrowLeftIcon } from '@phosphor-icons/react'
import type { ReactElement } from 'react'
import { Button } from 'app/components/ui/button'

/**
 * A dialog title with a way back to the dialog that opened it, such as a list's Settings
 * opening its stage or column editor. Drawn in the title so it sits where a person looks first.
 */
export function ModalBackTitle({
  title,
  backTo,
  onBack,
}: {
  title: string
  /** The dialog Back returns to, for its accessible name. */
  backTo: string
  onBack: () => void
}): ReactElement {
  return (
    <span className="flex items-center gap-2">
      <Button
        variant="icon"
        size="icon-sm"
        aria-label={`Back to ${backTo}`}
        title={`Back to ${backTo}`}
        onClick={onBack}
      >
        <ArrowLeftIcon size={16} weight="bold" />
      </Button>
      {title}
    </span>
  )
}
